module.exports = __webpack_public_path__ + "static/media/roccul.2d5693b8.png";